export enum AttendanceAspectEnum {
    eletivo = 1,
    urgencia = 2,
}